import ContentPostSettingsModalTab from "content/tabs/ContentPostSettingsModalTab";
import ConfirmModal from "modal/ConfirmModal";
import Message from "base/Message";

class DeleteTab extends ContentPostSettingsModalTab {

    bindEvents() {
        this.$element.on("click", ".js-delete", () => {
            ConfirmModal.confirm('Are you sure you want to permanently delete this item?', undefined, {showLoading: true}).then((done) => {
                this.contentPost.delete()
                    .then(() => this.contentPost.getContentType())
                    .then((content_type) => {
                        window.location = window.CONFIG.urls.website + content_type.baseUrl;
                    }).catch((e) => {
                    new Message(e.message, "Couldn't delete the item");
                    this.modal.show();
                });
            }).catch(() => {
                this.modal.show();
            });
            return false;
        })
    }

    buildElement() {

        return (
            eotwJSXFactory('div', null, [
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('h2', null, ["Delete"]),
                    eotwJSXFactory('p', null, ["This will remove this item entirely from your website."])
                ]),
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel js-delete", type: "button"}, ["Delete This Item"])
                ])
            ])
        );
    }


    getName() {
        return 'Delete';
    }
}

export default DeleteTab;
